module.exports = __webpack_public_path__ + "static/img/orangeLogo.2766c5d3.png";